<script setup>
const props = defineProps({
    sponsor: {
        type: Object,
        required: true,
    },
});
</script>
<template>
    <div class="sponsor bg-white p-4 rounded-(--radius)" v-aos :key="sponsor.id">
        <MessLink :href="sponsor.link" rel="sponsored">
            <MessImage :image="sponsor.sponsor_logo[0]" :alt="`${sponsor.name} logo`" />
        </MessLink>
    </div>
</template>

<style>
.sponsors-list .sponsor {
    /* Transitions for AOS */
    --timing: ease-in-out;
    --short-duration: 200ms;
    --duration: 350ms;
    --delay: calc(150ms + (var(--index) * 50ms));

    --standard: var(--short-duration) var(--timing) 0ms;
    --delayed: var(--duration) var(--timing) var(--delay);

    transition: scale var(--standard), filter var(--standard), opacity var(--delayed), transform var(--delayed);
}

.sponsors-list .sponsor .mess-image {
    aspect-ratio: 2.5/1.5;
    filter: grayscale(0.2);
    transition: scale var(--standard), filter var(--standard), opacity var(--delayed), transform var(--delayed);
}

.sponsors-list .sponsor .mess-image picture img {
    object-fit: contain;
}

.sponsors-list .sponsor:hover .mess-image,
.sponsors-list .sponsor:focus .mess-image {
    scale: 1.1;
    filter: grayscale(0) blur(0px);
}

.sponsors-list .sponsor.v-aos-before-enter.sponsor {
    opacity: 0;
}

.sponsors-list .sponsor.v-aos-before-enter .mess-image {
    opacity: 0;
    transform: translateY(1rem);
}
</style>
